import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { capitalize } from "../../../../../helpers/general";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

type Props = {
    isModalOpened: boolean;
    setIsModalOpened: React.Dispatch<React.SetStateAction<boolean>>;
    setIsValidateClickedModal: React.Dispatch<React.SetStateAction<boolean | number>>;
    msg: string;
};

export function ConfirmationMessage({
    setIsModalOpened,
    isModalOpened,
    setIsValidateClickedModal,
    msg,
}: Props) {
    const { t } = useTranslation();
    const toggle = () => setIsModalOpened(!isModalOpened);

    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader className="text-capitalize" toggle={toggle}>
                <StyledH2>{capitalize(t("Alert"))}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-0">{msg}</StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={toggle}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => setIsValidateClickedModal(true)}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
